import React, { FC } from 'react';
import { Flex, Typography } from '@duxton-web/ui';

import { DIFF_SHOWFOR, DiffShowFor_Keys } from './RolloutDiffUtils';
import { Rollout, RolloutTarget } from '@/lib/PlannerDTOs';
import {
  getRolloutTargetPosition,
  hasTargetPositionChanged,
} from '@/pages/RolloutTab/diffUtils';

interface OwnProps {
  baseRollout: Rollout;
  baseTarget: RolloutTarget;
  compareRollout: Rollout;
  compareTarget: RolloutTarget;
  showFor: (typeof DIFF_SHOWFOR)[DiffShowFor_Keys];
  index?: number;
  alternateLabel?: string;
}

const RolloutDiffIndex: FC<OwnProps> = ({
  baseRollout,
  baseTarget,
  compareRollout,
  compareTarget,
  showFor,
  index = null,
  alternateLabel = '',
}) => {
  let classname: string = '';
  let baseTargetIndex: number = -1;

  if (baseTarget && compareTarget && baseTarget.id) {
    // Use reusable utility functions
    baseTargetIndex = getRolloutTargetPosition(baseRollout, baseTarget.id);

    // Check if position changed using utility
    const positionChanged = hasTargetPositionChanged(
      baseRollout,
      compareRollout,
      baseTarget.id,
    );

    if (positionChanged) {
      classname =
        showFor === DIFF_SHOWFOR.BEFORE
          ? 'rollout-target-value-deleted'
          : showFor === DIFF_SHOWFOR.AFTER
            ? 'rollout-target-value-added'
            : '';
    }
  }

  return (
    <Flex gap={8} vertical>
      <Typography.Text strong type="secondary">
        {alternateLabel ? alternateLabel : 'Rollout Order'}
      </Typography.Text>
      <div className={`rollout-target-index ${classname}`}>
        {index || baseTargetIndex + 1}
      </div>
    </Flex>
  );
};

export default RolloutDiffIndex;
